import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type RegulatoryNoticesType = {
  title?: string;
  subTitles: { subTitle: string; link: string; target: string }[];
}[];

const RegulatoryNoticesOptions: RegulatoryNoticesType = [
  {
    subTitles: [
      {
        subTitle: 'ADA Wellness Notice',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'HIPAA Privacy Notice',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Medical Care D Creditable Coverage Notice',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'State Paid Family Leave Notices',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: "Women's Health and Cancer Rights Act",
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'HealthEquity Privacy Policy',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'HIPAA Special Enrollment Norice',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: "Newborns' and Mothers' Health Protection Act",
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'State Paid Sick Leave Notices',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Wellness Center Notice of Privacy Practices',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
    ],
  },
];

export type RegulatoryNoticesProps = {
  showRegulatoryNoticesModal: boolean;
  handleCloseRegulatoryNoticesModal: () => void;
};

function RegulatoryNoticesModal({
  showRegulatoryNoticesModal,
  handleCloseRegulatoryNoticesModal,
}: RegulatoryNoticesProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showRegulatoryNoticesModal}
        onHide={handleCloseRegulatoryNoticesModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true} leftIcon={light('folder')}>
          <h4 className="text-sm-20-lg-24">Regulatory Notices</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            {RegulatoryNoticesOptions.map(({ title, subTitles }, index) => {
              return (
                <Row key={index}>
                  <Col>
                    <h6
                      className={
                        'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-normal'
                      }
                    >
                      {title}
                    </h6>
                  </Col>
                  <Col className={'col-12 mc-layout-2-col mb-12'}>
                    {subTitles.map(({ subTitle, link, target }, index) => {
                      return (
                        <Row key={index}>
                          <Col>
                            <div
                              className={
                                'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                              }
                              key={index}
                            >
                              {subTitle}
                              <a
                                className={'text-decoration-none ms-auto'}
                                href={link}
                                target={target}
                              >
                                <FontAwesomeIcon icon={light('file-pdf')} />
                                <span className={'ms-5'}>PDF</span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              );
            })}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseRegulatoryNoticesModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RegulatoryNoticesModal;
